<div id="matProgressBar">
    <mat-progress-bar color="accent" [mode]="mode" *ngIf="visible" [bufferValue]="bufferValue" [value]="value"></mat-progress-bar>
</div>
